import { tskytheme } from '@jotta/ui/themes/tsky'
import { startApp } from '../App'

startApp(tskytheme)
